<template>
  <v-select
    :items="sports"
    v-bind="attributes"
    v-on="listeners"
    v-model="valueListener"
  ></v-select>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      sportsList: [
        {
          text: 'Baseball',
          value: 'baseball'
        },
        {
          text: 'Basketball',
          value: 'basketball'
        },
        {
          text: 'Football',
          value: 'football'
        },
        {
          text: 'Golf',
          value: 'golf'
        },
        {
          text: 'Hockey',
          value: 'hockey'
        },
        {
          text: 'Soccer',
          value: 'soccer'
        },
        {
          text: 'Tennis',
          value: 'tennis'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      sports: state => state.tag.sports
    }),
    attributes () {
      return {
        label: 'Sports',
        outlined: true,
        ...this.$attrs
      }
    },
    listeners () {
      return {
        ...this.$listeners
      }
    },
    valueListener: {
      get () {
        if (this.value) {
          return this.value.toLowerCase()
        }
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    ...mapActions({
      getSportList: 'tag/getSports'

    }),

    async getSportData () {
      await this.getSportList()
    }
  },
  created () {
    this.getSportData()
  }
}
</script>
